import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _class;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import Modal from 'components/Modal';
import { Dialog, DialogTitle, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import { Form, Input } from '../../../components/Form';
import styles from './CreditDepositModal.m.sass';
import ContentLoading from '../../../components/ContentLoading';
import ContentError from '../../../components/ContentError';
import EmptyState from '../../../components/EmptyState';
import BillingMethodItem from '../BillingMethods/BillingMethodItem';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { match } from '../../../utils/patternMatchUtil';
import round from 'lodash';
import formatCurrency from '../../../utils/formatCurrency';
import cx from 'classnames';
var CreditDepositModal = observer(_class = /*#__PURE__*/function (_React$Component) {
  function CreditDepositModal() {
    _classCallCheck(this, CreditDepositModal);
    return _callSuper(this, CreditDepositModal, arguments);
  }
  _inherits(CreditDepositModal, _React$Component);
  return _createClass(CreditDepositModal, [{
    key: "render",
    value: function render() {
      var _this$props$state = this.props.state,
        team = _this$props$state.team,
        billingStore = _this$props$state.billingStore,
        sessionStore = _this$props$state.sessionStore,
        state = _this$props$state.state;
      var creditViewState = state.creditViewState;
      return /*#__PURE__*/React.createElement(Modal, {
        onRequestClose: function onRequestClose() {
          return creditViewState.hideDepositModal();
        },
        isOpened: creditViewState.showingDepositModal,
        position: "top"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: creditViewState.saveDeposit.bind(creditViewState)
      }, /*#__PURE__*/React.createElement(Dialog, {
        className: styles.dialog
      }, !sessionStore.workspace.corporate && /*#__PURE__*/React.createElement("img", {
        className: styles.img,
        src: require('../../../assets/img/graphicMakeDeposit.svg')
      }), match(creditViewState.currentDepositTab, {
        SELECT_BILLING: function SELECT_BILLING() {
          return /*#__PURE__*/React.createElement(SelectBillingMethod, {
            creditViewState: creditViewState,
            billingStore: billingStore,
            team: team,
            sessionStore: sessionStore,
            state: state
          });
        },
        DEFAULTPAYMENT: function DEFAULTPAYMENT() {
          return /*#__PURE__*/React.createElement(DefaultPayment, {
            creditViewState: creditViewState
          });
        },
        CUSTOMPAYMENT: function CUSTOMPAYMENT() {
          return /*#__PURE__*/React.createElement(CustomPayment, {
            creditViewState: creditViewState
          });
        }
      }))));
    }
  }]);
}(React.Component)) || _class;
export { CreditDepositModal as default };
var DefaultPayment = observer(function DefaultPayment(_ref) {
  var creditViewState = _ref.creditViewState;
  var depositForm = creditViewState.depositForm;
  var method = creditViewState.billingStore.billingMethods.find(function (x) {
    return x.id === creditViewState.targetId;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTitle, {
    className: styles.dialogTitle
  }, "Make A Payment", /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, "Pay off this account's statement balance")), /*#__PURE__*/React.createElement(DialogContent, {
    className: styles.dialogContent
  }, method.balance >= 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceSubtitle
  }, "Your Balance is looking good! Get an additional 2.5% with further purchase of Taxfyle Credit!"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return creditViewState.showDepositCustom();
    },
    type: "submit",
    className: styles.is_awesome
  }, "Purchase")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceSubtitle
  }, "Click the button below to pay this account's balance of:"), /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceBalance
  }, /*#__PURE__*/React.createElement("strong", null, formatCurrency(round(method.balance / 100, 2)))), /*#__PURE__*/React.createElement("button", {
    onClick: action(function () {
      depositForm.depositAmount = Math.abs(round(method.balance / 100, 2));
    }),
    type: "submit",
    className: styles.is_awesome
  }, "Pay Invoice"), /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceCustomAmount
  }, "Or click", ' ', /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick() {
      return creditViewState.showDepositCustom();
    }
  }, "here"), ' ', "to insert a custom amount."))), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
    disabled: creditViewState.saveDeposit.pending,
    onClick: function onClick() {
      return creditViewState.hideDepositModal();
    }
  }, "Cancel"), method.balance < 0 && /*#__PURE__*/React.createElement(DialogButton, {
    onClick: action(function () {
      depositForm.depositAmount = Math.abs(round(method.balance / 100, 2));
    }),
    submit: true,
    primary: true,
    disabled: creditViewState.saveDeposit.pending
  }, creditViewState.saveDeposit.pending ? 'Adding' : 'Add')));
});
var CustomPayment = observer(function CustomPayment(_ref2) {
  var creditViewState = _ref2.creditViewState;
  var depositForm = creditViewState.depositForm;
  var method = creditViewState.billingStore.billingMethods.find(function (x) {
    return x.id === creditViewState.targetId;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTitle, {
    className: styles.dialogTitle
  }, "Make A Payment", /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, "Enter the amount for this payment.")), /*#__PURE__*/React.createElement(DialogContent, {
    className: styles.dialogContent
  }, /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceSubtitle
  }, "This account currently has a balance of:"), /*#__PURE__*/React.createElement("h1", {
    className: styles.invoiceBalance
  }, /*#__PURE__*/React.createElement("strong", {
    className: cx(method.balance >= 0 && styles.invoiceBalanceOkay)
  }, formatCurrency(round(method.balance / 100, 2)))), /*#__PURE__*/React.createElement(Input, {
    type: "number",
    min: 0,
    step: 0.01,
    model: depositForm,
    field: "depositAmount",
    label: "Deposit Custom Amount"
  })), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
    disabled: creditViewState.saveDeposit.pending,
    onClick: function onClick() {
      return creditViewState.hideDepositModal();
    }
  }, "Cancel"), /*#__PURE__*/React.createElement(DialogButton, {
    submit: true,
    primary: true,
    disabled: creditViewState.saveDeposit.pending
  }, creditViewState.saveDeposit.pending ? 'Adding' : 'Add')));
});
var SelectBillingMethod = observer(function SelectBillingMethod(_ref3) {
  var creditViewState = _ref3.creditViewState,
    billingStore = _ref3.billingStore,
    team = _ref3.team,
    sessionStore = _ref3.sessionStore,
    state = _ref3.state;
  var emptyState = /*#__PURE__*/React.createElement(EmptyState, {
    title: "No billing methods."
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DialogTitle, {
    className: styles.dialogTitle
  }, "Make A Payment", /*#__PURE__*/React.createElement("p", {
    className: styles.subTitle
  }, "Select a billing method for this payment")), /*#__PURE__*/React.createElement(DialogContent, {
    className: styles.dialogContent
  }, billingStore.activate.match({
    pending: function pending() {
      return /*#__PURE__*/React.createElement(ContentLoading, {
        small: true
      });
    },
    rejected: function rejected(err) {
      return /*#__PURE__*/React.createElement(ContentError, {
        error: err
      });
    },
    resolved: function resolved() {
      var profile = team ? billingStore.teamBillingProfile(team.id) : billingStore.individualBillingProfile;
      var methods = profile ? profile.billingMethods.filter(function (x) {
        return x.type !== 'Credit';
      }) : [];
      return /*#__PURE__*/React.createElement(React.Fragment, null, methods.length === 0 ? emptyState : methods.map(function (method) {
        return /*#__PURE__*/React.createElement(BillingMethodItem, {
          key: method.id,
          method: method,
          billingStore: billingStore,
          state: state,
          sessionStore: sessionStore,
          workspace: sessionStore.workspace,
          onClick: function onClick() {
            return creditViewState.depositSelectBillingMethod(method.id);
          }
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.filler
      }));
    }
  })), /*#__PURE__*/React.createElement(DialogFooter, null, /*#__PURE__*/React.createElement(DialogButton, {
    disabled: creditViewState.saveDeposit.pending,
    onClick: function onClick() {
      return creditViewState.hideDepositModal();
    }
  }, "Cancel")), /*#__PURE__*/React.createElement(ConfirmDialog, {
    position: "top",
    state: billingStore.deleteBillingMethodDialog,
    danger: true,
    yes: "Delete Payment Method"
  }, "Are you sure you want to delete this payment method?"));
});
//# sourceMappingURL=index.js.map
